module.exports = __webpack_public_path__ + "img/purim-2017-thumbnail.a0c2791a.jpeg";